import en from "./en";
const de = {
  ...en,
  nav: {
    home: "Startseite",
    about: "Die Allianz",
    markets: "Märkte",
    services: "Leistungen",
    partners: "Partner",
    manufacturers: "Für Hersteller",
    news: "News",
    contact: "Kontakt",
    partner_cta: "Partner werden",
  },
  hero: {
    eyebrow: "European Electric Mobility Alliance",
    title_line1: "Die europäische Vertriebsplattform",
    title_line2: "für Elektromobilität",
    subtitle: "Wir verbinden Hersteller mit dem erfahrensten Vertriebsnetzwerk Europas. Wir importieren nicht nur Fahrzeuge. Wir bauen Marken auf.",
    cta_primary: "Partner werden",
    cta_secondary: "Die Allianz entdecken",
    scroll: "Scrollen zum Entdecken",
  },
  cta_final: {
    eyebrow: "Strategische Partnerschaft",
    title: "Bereit für Ihre Expansion in Europa?",
    subtitle: "Kooperieren Sie mit EEMA und nutzen Sie eine etablierte Handelsplattform in den strategischsten Elektromobilitätsmärkten Europas.",
    button: "Termin anfragen",
  },
};
export default de;
